export const getall = (fields) => {
  return `{getQuiz{${fields.join(" ")}}}`;
};

export const getQuestionByQuizzId = (id, fields) => {
  return `{getQues(quiz_id:${id}){${fields.join(" ")}
                                      multiChoice
                                      sumVote
                                       quetionsOption{id
                                         opt_text
                                         is_active
                                         createdAt
                                         counterVote
                                         updatedAt}
                                         QuesQuizz{id,title,is_active,createdAt,updatedAt}
                                    }
                                    
              
                }`;
};

export const getAllQuetionQuery = (fields, child) => {
  return `{getAllQuestions{${fields.join(" ")} QuesQuizz{${child.join(
    " "
  )}} }}`;
};

export const _getAllQuizzQuery = () => `{
  _findAllQuizes{
                   id
                   title
                   multiChoice
                   sumVotes
                   donutChart
                   progresbarChart
                   status
                   createdAt
                   updatedAt
                   _answers{id
                            opt_text
                            AnswersCount
                            createdAt
                            updatedAt
                            }
                   }

}`;

export const _getAnswersByQuizIdQuery = (quiz_id) => `{

  _getAnswerByQuizId(quiz_id:${quiz_id}){ id 
                                  opt_text
                                  AnswersCount
                                  createdAt
                                   updatedAt
                                }
  
  }`;

export const _getQuizByIdQuery = (id) => `{
  _findOneQuiz(id:${id}){ id
                       title
                       status
                       multiChoice
                       sumVotes
                       createdAt
                       updatedAt 
                       donutChart
                       progresbarChart
                       _answers{id
                                opt_text
                                createdAt
                                updatedAt
                                AnswersCount
                                status
                                }  
                         }
  
  }
 `;

export const getVoteByRadio = (radio_id, per_page, page) => `
 
 {
  getQuizByRadioPaginate(radio_id:${radio_id},per_page:${per_page},page:${page}){
   items{
          id
          title
          is_active
          createdAt
          updatedAt
         }
    
   itemCount
   totalItems
  
  }
  
  }
 `;

export const _getQuizByRadio = (radio_id, per_page, page) => `{
  _findAllQuizesByradioPagination(radio_id:${radio_id},per_page:${per_page},page:${page}){
      items{
        id
          title 
          status 
          multiChoice
          sumVotes
          donutChart
          progresbarChart
         }
       totalItems
       itemCount
      }
  }`;
